import { FETCH_ANNOUNCEMENT } from '../constants/action-types';

const initState = {
    announcements : []
}

const announceReducer = (state = initState, action) => {
    switch(action.type){
        case FETCH_ANNOUNCEMENT:
            return {
                ...state,
                announcements: [... state.announcements, action.announcements]
            }
        default:
            return state;
    }
}

export default announceReducer